import React from "react";
import {Row, Col, Card} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import config from '../../../config';
import ReactHtmlParser from 'react-html-parser';
import {getImageBySizeFromCDN} from "../../common/utils";
import {useSelector} from "react-redux";

const Guidelines = ({mobile_big, mobile_small}) => {
    const {home_vetted} = useSelector((state) => state.appReducer.init)
    if(home_vetted.length === 0) return null;
    let homepage_vetted_img = home_vetted[0].image;
    if(mobile_big){
        if(mobile_small){
            homepage_vetted_img = home_vetted[0].mobile_image;
        } else {
            homepage_vetted_img = home_vetted[0].table_image;
        }
    }
    return (
        <div className="home_guide">
            <Row xs={1} sm={2}>
                <Col className="h-g-t" xs={12} sm={6}>
                    <div className="h-g-t-c">
                        <h2>{ReactHtmlParser(home_vetted[0].title)}</h2>
                        <p>
                            {ReactHtmlParser(home_vetted[0].sub_copy)}
                        </p>
                        <a href={home_vetted[0].url} target="_blank" rel="noopener noreferrer">
                            Read More <i/>
                        </a>
                    </div>
                </Col>
                <Col className="h-g-s" xs={12} sm={6}>
                    <Card>
                        <LazyLoadImage
                            className="card-img"
                            alt="Card image"
                            title="Card image"
                            src={getImageBySizeFromCDN(`${homepage_vetted_img}`, "f=auto,q=90,w=593")}
                            srcSet={`${getImageBySizeFromCDN(`${homepage_vetted_img}`, "f=auto,q=90,w=544")} 544px,
                            ${getImageBySizeFromCDN(`${homepage_vetted_img}`, "f=auto,q=90,w=367")} 367w,
                            ${getImageBySizeFromCDN(`${homepage_vetted_img}`, "f=auto,q=90,w=474")} 474w,
                            ${getImageBySizeFromCDN(`${homepage_vetted_img}`, "f=auto,q=90,w=593")} 593w,
                            ${getImageBySizeFromCDN(`${homepage_vetted_img}`, "f=auto,q=90,w=750")} 750w`}
                            sizes="(max-width: 375px) 375px,
                                    (max-width: 544px) 544px,
                                    (max-width: 768px) 367px,
                                    (max-width: 992px) 474px,
                                    593px"
                            width="593"
                            height="524"
                        />
                    </Card>
                </Col>
            </Row>
        </div>
    )
};

export default Guidelines;